import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import Datetime from 'react-datetime'
import { KTSVG } from '_metronic/helpers'

import useViewModel from './ViewModel'

const ExportDailyReportModal: React.FC = () => {
  const {
    modalsRoot,
    isOpenExportDailyReportModal,
    reportDate,
    dateError,
    apiError,
    isExporting,
    isConfirmDisabled,
    handleClose,
    handleDateChange,
    handleConfirm,
  } = useViewModel()

  return createPortal(
    <Modal
      id='kt_modal_export_daily_report'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={isOpenExportDailyReportModal}
      onHide={handleClose}
      backdrop={isExporting ? 'static' : true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>Export Daily Report</h2>
          <div
            className='btn btn-sm btn-icon btn-active-light-danger'
            onClick={handleClose}
            style={{ pointerEvents: isExporting ? 'none' : 'auto', opacity: isExporting ? 0.5 : 1 }}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
        </div>

        <div className='modal-body py-lg-10 px-lg-10'>
          <div className='mb-5'>
            <label className='form-label fw-bold'>วันที่รายงาน</label>
            <Datetime
              locale='en'
              dateFormat='DD/MM/YYYY'
              timeFormat={false}
              value={reportDate ?? undefined}
              onChange={handleDateChange}
              inputProps={{
                placeholder: 'dd/mm/yyyy',
                disabled: isExporting,
              }}
              renderInput={props => <input {...props} autoComplete='off' />}
              closeOnClickOutside
              className='filter-date-input w-100'
            />
            {dateError && <div className='text-danger fs-7 mt-2'>{dateError}</div>}
            {apiError && <div className='text-danger fs-7 mt-2'>{apiError}</div>}
          </div>

          {isExporting && (
            <div className='progress h-8px mb-5'>
              <div
                className='progress-bar progress-bar-striped progress-bar-animated bg-primary'
                role='progressbar'
                style={{ width: '100%' }}
              />
            </div>
          )}
        </div>

        <div className='modal-footer'>
          <button className='btn btn-light fw-bold' onClick={handleClose} disabled={isExporting}>
            ยกเลิก
          </button>
          <button
            className='btn btn-primary fw-bold'
            onClick={handleConfirm}
            disabled={isConfirmDisabled}>
            ยืนยัน
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default ExportDailyReportModal
